import React from 'react';
import { Error as ErrorIcon } from '@mui/icons-material';
import { Header } from '../components/Header/Header';
import './ExpiredPage.scss';

export function ExpiredPage() {
  return (
    <div className="expired-page">
      <Header />
      <div className="expired-page__content">
        <div className="expired-page__icon">
          <ErrorIcon sx={{ fontSize: 64, color: '#dc3545' }} />
        </div>
        <h2 className="expired-page__title">Link Expired</h2>
        <p className="expired-page__message">
          This signing link has expired. Signing links are valid for 1 hour
          after they are generated.
        </p>
        <p className="expired-page__note">
          Please contact your healthcare provider to request a new signing link.
        </p>
      </div>
    </div>
  );
}

export default ExpiredPage;
